import _forOwn from "./forOwn";
var exports = {};
var forOwn = _forOwn;
/**
 * Get object size
 */

function size(obj) {
  var count = 0;
  forOwn(obj, function () {
    count++;
  });
  return count;
}

exports = size;
export default exports;